import React, { useState } from "react";
import { Link } from 'react-router-dom';
import ProfileMenu from "../ProfileMenu";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import { Logo, Modal, Button, CopyValue } from "..";
import { useNavigate } from "react-router-dom";
import ProfileSwitch from "./profileSwitch";
import { useClientSettings } from "Hooks/useClientSettings";
import { useUserPreference } from "../../Hooks/useUserPreference";
import useMobileCheck from "../../Hooks/useMobileCheck";

function FullSidebar({ options = [], content }) {
	const { support_email, support_phone } = useClientSettings();
	const { showSidebar } = useUserPreference();
	const { windowSize } = useMobileCheck();
	const [showSupport, setShowSupport] = useState(false);
	const NAVIGATE = useNavigate();
	const pathname = window.location.pathname;
	const isMobileSidebar = windowSize < 1200;

	const closeOnMobileAction = () => {
		if (isMobileSidebar) {
			showSidebar(false);
		}
	};

	return (
		<>
			<div className="sidebar min-h-0">
				<div className={`flex-1 min-h-0 overflow-y-auto scrollbar-autohide ${isMobileSidebar ? "p-3" : "p-4"}`}>
					<ProfileMenu onAction={closeOnMobileAction} compact={isMobileSidebar} />
					<ProfileSwitch onAction={closeOnMobileAction} compact={isMobileSidebar} />
					<div className={`menu ${isMobileSidebar ? "mt-2" : "mt-4"}`}>
						{options.map((option, index) => {
							if (typeof option === "string") {
								return (
									<div key={`label-${index}`} className="label">
										{option}
									</div>
								);
							} else {
								return (
									<div key={index}>
										<div
											className={`item flex justify-between ${pathname.startsWith(option.route) ? "active" : ""}`}
											onClick={() => {
												if (option.route) {
													NAVIGATE(option.route);
												} else {
													option.onClick?.();
												}
												closeOnMobileAction();
											}}
										>
											<span className="align-center gap-x-4">
												{option.icon}
												{option.label}{" "}
											</span>
											<span>{option.children && <FiChevronDown />}</span>
										</div>
										{option.children?.length > 0 && (
											<div key={`sub-${index}`} className={`sub-items ${pathname.startsWith(option.route) ? "active" : ""}`}>
												{option.children.map((child, i) => {
													return (
														<div
															key={`child-${i}`}
															className={`sub-item gap-x-4 ${pathname.startsWith(child.route) ? "active" : ""}`}
															onClick={() => {
																if (child.route) {
																	NAVIGATE(child.route);
																} else {
																	child.onClick?.();
																}
																closeOnMobileAction();
															}}
														>
															<div className="flex">
																<FiChevronRight className="mr-4 arrow" />
																{child.icon}
															</div>
															{child.label}
														</div>
													);
												})}
											</div>
										)}
									</div>
								);
							}
						})}
					</div>
				</div>
				<div className={`space-y-1 shrink-0 ${isMobileSidebar ? "px-2 py-0.5" : "p-2 space-y-2"}`}>
					{!isMobileSidebar && content}
					{!isMobileSidebar && (
						<div className="flex justify-center py-0.5">
							<Logo className="items-center font-bold text-secondary" short={true} dotSize="3" dot="ml-2" />
						</div>
					)}
				</div>
				<div className={`flex shrink-0 gap-2 px-2 pb-2 ${isMobileSidebar ? "items-center pt-0.5" : "pt-1"}`}>
					{isMobileSidebar && <img src="https://cdn.travelwings.com/assets/corp/images/logo_short.png" alt="Travelwings logo" className="w-[50px] h-[50px] object-contain shrink-0" />}
					<Button className={`btn-sm ${isMobileSidebar ? "flex-1 !py-1.5 !text-xs" : "m-auto my-3"}`} variant="outlined" onClick={() => setShowSupport(true)}>
						Need Support ?
					</Button>
					<Link
						to="/app/faqs"
						className={`btn btn-outlined btn-sm ${isMobileSidebar ? "flex-1 !py-1.5 !text-xs text-center" : "my-3 m-auto"}`}
						onClick={() => {
							closeOnMobileAction();
						}}
					>
						FAQ's
					</Link>
				</div>
				<Modal open={showSupport} onClose={() => setShowSupport(false)}>
					<div className="p-8 space-y-2">
						<div className="mb-4">
							<h3 className="font-bold">Reach out to us</h3>
							<p className="text-sm">For any questions or support, please contact us using the following information:</p>
						</div>
						<p>
							<b>Phone</b> <CopyValue>{support_phone}</CopyValue>
						</p>
						<p>
							<b>Email</b> <CopyValue>{support_email}</CopyValue>
						</p>
					</div>
				</Modal>
			</div>
		</>
	);
}

export default FullSidebar;
